import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const PersonDoneIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M12.2894 8C12.2894 10.21 10.4563 12 8.19296 12 5.92966 12 4.09648 10.21 4.09648 8 4.09648 5.79 5.92966 4 8.19296 4 10.4563 4 12.2894 5.79 12.2894 8zM10.2412 8C10.2412 6.9 9.3195 6 8.19296 6 7.06643 6 6.14472 6.9 6.14472 8 6.14472 9.1 7.06643 10 8.19296 10 9.3195 10 10.2412 9.1 10.2412 8zM8.19296 13C10.784 13 13.0166 13.7 14.7371 14.56 15.7612 15.07 16.3859 16.1 16.3859 17.22V20H0V17.22C0 16.1.624713 15.07 1.64883 14.56 3.36936 13.7 5.60194 13 8.19296 13zM2.04824 17.22V18H14.3377V17.22C14.3377 16.84 14.1329 16.5 13.8051 16.34 12.5864 15.73 10.6201 15 8.19296 15 5.7658 15 3.79949 15.73 2.58078 16.34 2.25307 16.5 2.04824 16.84 2.04824 17.22z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M15.0016 10.6549L16.5991 9.16664L18.0059 11.0269L22.7836 6.17586L24 7.63548L17.8594 14.0607L15.0016 10.6549Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
